// src/components/contact/ContactForm.jsx
import React, { useState } from 'react';

const ContactForm = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submissionStatus, setSubmissionStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmissionStatus('submitting');

    // In a real application, you would send this data to your backend
    // for processing (e.g., sending an email).
    console.log('Form submitted:', { name, email, message });

    // Simulate a successful submission after a short delay
    setTimeout(() => {
      setName('');
      setEmail('');
      setMessage('');
      setSubmissionStatus('success');
    }, 1500);

    // You might want to reset the status after a longer period
    // setTimeout(() => {
    //   setSubmissionStatus(null);
    // }, 5000);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label htmlFor="name" className="block text-gray-700 text-sm font-bold mb-2">
          Name:
        </label>
        <input
          type="text"
          id="name"
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
      </div>
      <div>
        <label htmlFor="email" className="block text-gray-700 text-sm font-bold mb-2">
          Email:
        </label>
        <input
          type="email"
          id="email"
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      <div>
        <label htmlFor="message" className="block text-gray-700 text-sm font-bold mb-2">
          Message:
        </label>
        <textarea
          id="message"
          rows="4"
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
        ></textarea>
      </div>
      <button
        type="submit"
        className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition duration-300"
        disabled={submissionStatus === 'submitting'}
      >
        {submissionStatus === 'submitting' ? 'Sending...' : 'Send Message'}
      </button>
      {submissionStatus === 'success' && (
        <p className="text-green-500 mt-2">Message sent successfully!</p>
      )}
      {submissionStatus === 'error' && (
        <p className="text-red-500 mt-2">There was an error sending your message.</p>
      )}
    </form>
  );
};

export default ContactForm;